export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "ago": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" ago"])}
      },
      "zh": {
        "ago": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["以前"])}
      }
    }
  })
}
